import { UAParser } from 'ua-parser-js';

let BASE_URL = window.BASE_URL
if (process.env.NODE_ENV === 'development') {
  BASE_URL = BASE_URL.dev
} else if (process.env.NODE_ENV === 'production') {
  BASE_URL = BASE_URL.proc
} else if (process.env.NODE_ENV === 'test') {
  BASE_URL = BASE_URL.test
} else if (process.env.NODE_ENV === 'test-pro') {
  BASE_URL = BASE_URL.testPro
} else if (process.env.NODE_ENV === 'prd') {
  BASE_URL = BASE_URL.prd
}
const webAppPageCode = ['qr_code_app_jump', 'qr_code_app_download']
class Track {
  aliyun_track_name = process.env.NODE_ENV === 'production' ? 'test-basf-log' : 'test-basf-log';
  track_pv;
  track_click;
  // 上一页obj
  previousObj = {};
  // 当前页obj
  currentObj = {};
  // 下一页名字
  nextName = "";
  // 下一页参数
  nextPar = "";

  constructor() { }

  /**
   * 曝光
   * @param page_code:string 当前页编号
   * @param extend_data:string 当前页扩展参数
   */
  webTrackPv(obj) {
    // 当前页编号
    if (obj && obj['page_code']) {
      this.currentObj['page_code'] = obj['page_code'];
      delete obj['page_code'];
    }
    // 当前页扩展参数
    if (obj && obj['extend_data']) {
      this.currentObj['extend_data'] = obj['extend_data'];
      delete obj['extend_data'];
    }
    if (!this.track_pv) this.track_pv = new window.Tracker(BASE_URL + '/visitDataLog/visit');
    const params = { ...obj, ...this.getTrackParam() }
    if (webAppPageCode.includes(params.page_code)) {
      params.application_platform = 'webApp'
    }
    this.objToAry(params).forEach((item) => {
      this.track_pv.push(item.key, item.value);
    });
    this.track_pv.logger();
  }

  /**
   * 点击
   * @param des_code:string 下一页编号
   * @param des_extend_data:string 下一页扩展参数
   * @param click_code:string 点击编号
   * @param click_extend_data:string 点击扩展参数
   */
  webTrackClick(obj) {
    // 下一页编号
    if (obj && obj['des_code']) {
      this.nextName = obj['des_code'];
      delete obj['des_code'];
    }
    // 下一页扩展参数
    if (obj && obj['des_extend_data']) {
      this.nextPar = obj['des_extend_data'];
      delete obj['des_extend_data'];
    }
    if (!this.track_click) this.track_click = new window.Tracker(BASE_URL + '/visitDataLog/hit');
    const params = { ...obj, ...this.getTrackParam(), click_time: new Date().getTime() }
    if (webAppPageCode.includes(params.page_code)) {
      params.application_platform = 'webApp'
    }
    this.objToAry(params).forEach((item) => {
      this.track_click.push(item.key, item.value);
    });
    this.track_click.logger();
  }

  // 对象转数组
  objToAry(obj) {
    let list = Object.keys(obj).map(key => ({
      key,
      value: obj[key]
    }));
    return list;
  }

  // 获取track参数
  getTrackParam() {
    let trackObj = {};

    // 通过路由获取信息
    trackObj['last_page_code'] = this.previousObj['name'] ? this.getPageCode(this.previousObj['name']) : '';
    trackObj['last_extend_data'] = this.previousObj['fullPath'] ? this.getPagePar(this.previousObj['fullPath']) : '';

    // 当前页编号
    if (this.currentObj['page_code']) {
      trackObj['page_code'] = this.currentObj['page_code'];
    } else if (this.currentObj['name']) {
      trackObj['page_code'] = this.getPageCode(this.currentObj['name']);
    }
    // 当前页扩展参数
    if (this.currentObj['extend_data']) {
      trackObj['extend_data'] = this.currentObj['extend_data'];
    } else if (this.currentObj['fullPath']) {
      trackObj['extend_data'] = this.getPagePar(this.currentObj['fullPath']);
    }

    if (this.nextName) {
      trackObj['des_code'] = this.nextName;
      trackObj['des_extend_data'] = this.nextPar;
      // 因为不是所有页面都要下一页，比如pv就不需要，所以用完就清空
      this.nextName = "";
      this.nextPar = "";
    }

    // 浏览当前页面的开始时间
    if (window.visit_time) trackObj['visit_time'] = window.visit_time;
    const utm_source = sessionStorage.getItem('utm_source')
    if (utm_source) trackObj['utm_source'] = utm_source

    let webTracking = sessionStorage.getItem("webTracking");
    // 判断sessionStorage是否有默认参数
    if (webTracking) {
      try {
        Object.assign(trackObj, JSON.parse(webTracking));
      } catch (err) {
        console.log(err);
      }
    } else {
      // 如果没有，就使用默认数据，主要用在login页面，此时没有用户信息
      this.setTrackParam();
      // 设置完再取
      Object.assign(trackObj, JSON.parse(sessionStorage.getItem("webTracking")));
    }
    return trackObj;
  }

  getDeviceId() {
    try {
      let sessId = localStorage.getItem('sessId')
      if (!sessId) {
        const time = new Date().getTime()
        const random = Math.ceil(Math.random() * time)
        sessId = `${time}-${random}`
        localStorage.setItem('sessId', sessId)
      }
      return sessId
    } catch (e) {
      return 'sessIdError'
    }
  }

  // 设置track参数
  setTrackParam(obj) {
    let trackObj = {};
    // 这里不用判断是否有sessionStorage，简单粗暴直接覆盖，因为这个方法不会每个页面都调用
    let parser = new UAParser();
    // 获取sessionId（时间戳）

    Object.assign(trackObj, obj, {
      // uid: '1', // 用户id
      // account: 'zhangsan', // 用户登录账户名
      system_type: parser.getOS().name,
      system_version: parser.getOS().name + parser.getOS().version,
      application_platform: 'PC',
      device_id: this.getDeviceId()
      // visit_time: 1568861078744, // 浏览当前页面的开始时间
    });
    try {
      sessionStorage.setItem("webTracking", JSON.stringify(trackObj));
    } catch (err) {
      console.log(err);
    }
  }

  // 获取页面名字
  getPageCode(pageName) {
    // 页面名字映射，router name -> 埋点文档name
    let nameMap = {
      // 登录页面
      'homeoutside': 'landing',
      // 首页
      'HOME': 'home',
      // 用户洞察
      'consumerInsights':'web_consumer_insight',
      'marketOverview':'web_consumer_insight_market_overview',
      'forClaims':'web_consumer_insight_top_ranking_for_claim',
      'forProducts':'web_consumer_insight_top_ranking_for_product',
      'forBrand':'web_consumer_insight_top_ranking_for_brand',
      'trendDetail':'web_consumer_insight_trend_detail',
      // INCI
      'ingredientSelectDetail': 'web_INCI_detail',
      //BASF Product
      'basfProductDetail': 'web_BASF_product_detail',
      //配方
      "formulationList": "web_formulation_list",
      "formulationDetail": "web_formulation_detail",
      // 品牌
      'brandList': 'web_brand_list',
      'brandDetail': 'web_brand_detail',
      // 比较
      'brandComparison': 'my_comparison_brand',
      'productComparison': 'my_comparison_consumer_product',
      'ingredientComparison': 'my_comparison_INCI',
      'formulationComparison': 'my_comparison_formulation',
      // concept
      'conceptIndex': 'web_concept_main',
      'conceptList': 'web_concept_list_new',
      'oldCconceptList': 'web_concept_list_old',
      'conceptDetail': 'web_concept_detail',
      // consumerProduct
      'productList': 'web_consumer_product_list',
      'productDetail': 'web_consumer_product_detail',
      // E-Learning
      'introductionVideoList': 'web_elearning_tips_for_Dlite3x',
      'eLearningDetail': 'web_elearning_webinar_detail',
      'coownerSetting': 'web_co_owner_setting',
      'messageCenter': 'web_message_center',
      'landingPage': 'qr_code_app_download',
      'ingredientSelectList': 'web_INCI_list',
      'categoryDetail': 'media_list',
      'media': 'media',
      'channelDetail': 'media_list',
      'tagSearch': 'media_tag',
      'videoDetail': 'media_detail',
      'webinarClient': 'webinar_list',
      'webinarDetail': 'webinar_detail',
      'homePage': 'homepage',
      'myOrder': 'web_my_order',
      'comprehensiveSearch': 'web_comprehensive_search',
      'myProfile': 'my_profile',
      'eventList': 'web_event',
      'eventDetail': 'web_event_detail',
      'eventFormulationList': 'web_event_formulation_list',
      'eventBasfProductList': 'web_event_BASF_product_list',
      'user_management': 'user_management',
      'data_upload': 'data_upload',
      'management': 'management',
      'data_relationship': 'data_relationship',
      'general_management': 'general_management',
      'dlitE3X': 'my_dlite3x',
      'myComments': 'web_my_comments',
      'myFavorites': 'web_my_favorites',
      'recentlyViewed': 'web_recently_viewed',
      'documentRequest': 'web_document_request',
      'jumpPage': 'qr_code_app_jump'
    }
    return nameMap[pageName];
  }

  // 获取页面参数，拼接成对象字符串
  getPagePar (pageName) {
    let par = "";
    let obj = {};
    let urlSplit = pageName.split('?');
    if (urlSplit.length > 1) {
      let parList = urlSplit[1].split("&");
      parList.forEach((item) => {
        obj[item.split("=")[0]] = decodeURIComponent(item.split("=")[1]);
      });
    }
    par = JSON.stringify(obj);
    return par === "{}" ? "" : par;
  }

  // 获取上一页url
  getPreviousObj(obj) {
    this.previousObj = {...obj};
  }

  // 获取当前页url
  getCurrentObj(obj) {
    this.currentObj = {...obj};
  }
}

export default new Track();



// WEBPACK FOOTER //
// ./src/utils/web-tracking.js